$(document).ready(function () {
    let loadmoreButton = $('#events-loadmore');
    let postsPerPage = $('.past-events').data('posts-per-page');
    let postsPerload = 3;
    let eventsContainer = $('#events-container');
    let terms = $('.past-events .events-term');
    let activeTerms = '';
    let ajaxUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/wp-admin/admin-ajax.php`;
    let paged = postsPerload;
    let maxPosts = loadmoreButton.data('posts-count') ?? 0;
    let maxPages = 0;
    if (maxPosts > postsPerPage) {
        maxPages = Math.ceil((maxPosts - postsPerPage) / postsPerload)
    }
    let cardUpcoming = $('.card-upcoming');
    let upcomingPosts = [];
    let cardUpcomingPostCount = {};

    cardUpcoming.each(function (index, value) {
        let card = $(this);
        upcomingPosts.push(card.find('.tags.custom li').data('term-id'));
    });

    $.each(upcomingPosts, function (index, value) {
        if (cardUpcomingPostCount[value]) {
            cardUpcomingPostCount[value]++;
        } else {
            cardUpcomingPostCount[value] = 1;
        }
    });

    terms.each(function (index, value) {
        let term = $(this);
        term.on('click', function (event) {
            event.preventDefault();
            paged = postsPerload;
            terms.removeClass('active');
            terms.removeAttr('style');
            term.addClass('active');
            term.attr('style', 'pointer-events: none;');
            activeTerms = term.data('term-id');
            maxPosts = term.data('posts-count');

            if (cardUpcomingPostCount[activeTerms] > 0) {
                maxPosts -= cardUpcomingPostCount[activeTerms]
            }

            if (maxPosts > 0 && maxPosts > postsPerPage) {
                maxPages = Math.ceil((maxPosts - postsPerPage) / postsPerload)
            } else {
                maxPages = 0;
            }

            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: {
                    'action': 'load_events_posts',
                    'term_id': activeTerms,
                    'paged': 1,
                    'posts_load': postsPerPage
                },
                success: function (data) {
                    eventsContainer.html(data.html);
                    if (maxPages > 0) {
                        loadmoreButton.removeClass('d-none');
                    } else {
                        loadmoreButton.addClass('d-none');
                    }
                }
            });
        });
    });

    loadmoreButton.on('click', function () {
        loadmoreButton.addClass('loading-start').attr('disabled', 'disabled');
        paged++;
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                'action': 'load_events_posts',
                'term_id': activeTerms,
                'paged': paged,
                'posts_load': postsPerload
            },
            success: function (data) {
                eventsContainer.append(data.html);
                if ((paged - postsPerload) >= maxPages) loadmoreButton.addClass('d-none');
                loadmoreButton.removeClass('loading-start').removeAttr('disabled');
            }
        });
    });
});